<div class="p-5 bg-light-grey rounded-md text-dark-grey">
  <div class="flex justify-between items-start mb-3">
    <div class="flex flex-col">
      <span class="font-medium">{{ activityTypeLabel() }}</span>
      <span class="text-mid-grey">{{ dayjs(activity().scheduledDate) | dayjsFormat: 'date' }}</span>
    </div>

    @if (this.activity().scheduledTime) {
      <span class="text-mid-grey"
        >Start: {{ dayjs(this.activity().scheduledTime) | dayjsFormat: 'time' }} Uhr</span
      >
    } @else {
      <span class="text-mid-grey">ganztägig</span>
    }
  </div>

  <ng-content></ng-content>
</div>
